// stupid bug
// I think it only supports strings or template strings (not variables)
// X failed  "../assets/img/avatars/titles/哲學家" + anchor + "@2x_epic.png"
// O correct `../assets/img/avatars/titles/哲學家${anchor}@2x${advanced}.png`,
import i18n from "../locales/index.js";
const { t } = i18n.global;

export function getTitleDesc(myTitle) {
  let wholeTitleDescription = [
    {
      key: "Knight",
      title: "Knight",
      description: t(
        "a-person-who-is-a-noble-warrior-wears-a-metal-armor-and-rides-a-war-horse"
      ),
    },
    {
      key: "Villager",
      title: "Villager",
      description: t("a-person-who-lives-in-a-village"),
    },
    {
      key: "Traveler",
      title: "Traveler",
      description: t("a-person-who-is-traveling-far-from-home"),
    },
    {
      key: "Blacksmith",
      title: "Blacksmith",
      description: t(
        "a-person-who-specializes-in-forging-metal-to-create-things"
      ),
    },
    {
      key: "Businessman",
      title: "Businessman",
      description: t("a-person-who-does-the-trade-business-to-make-profit"),
    },
    {
      key: "Farmer",
      title: "Farmer",
      description: t("a-person-who-cultivates-crops-or-raises-animals"),
    },
    {
      key: "Messenger",
      title: "Messenger",
      description: t(
        "a-person-who-takes-a-message-or-goods-from-one-person-to-another"
      ),
    },
    {
      key: "Fisherman",
      title: "Fisherman",
      description: t("a-person-who-catches-fish-from-the-sea"),
    },
    {
      key: "Carpenter",
      title: "Carpenter",
      description: t("a-person-who-builds-or-repairs-the-wooden-product"),
    },
    {
      key: "Sage",
      title: "Sage",
      description: t("a-person-who-is-regarded-as-being-very-wise"),
    },
    {
      key: "Berserker",
      title: "Berserker",
      description: t("a-person-who-fights-fearlessly-into-battle"),
    },
    {
      key: "Paladin",
      title: "Paladin",
      description: t("a-person-who-fights-hard-for-the-faith-they-believe-in"),
    },
    {
      key: "Archbishop",
      title: "Archbishop",
      description: t("a-person-who-is-a-servant-of-god"),
    },
    {
      key: "Scientist",
      title: "Scientist",
      description: t(
        "a-person-who-studies-science-and-carries-out-different-experiments"
      ),
    },
    {
      key: "Alchemist",
      title: "Alchemist",
      description: t(
        "a-person-who-transforms-something-through-a-magical-process"
      ),
    },
    {
      key: "Monk",
      title: "Monk",
      description: t("a-person-who-is-devoted-to-contemplation-and-prayer"),
    },
    {
      key: "Houngan",
      title: "Houngan",
      description: t(
        "a-person-who-leads-believers-to-perform-religious-duties"
      ),
    },
    {
      key: "Philosopher",
      title: "Philosopher",
      description: t(
        "a-person-who-seeks-the-secret-of-knowledge-and-the-meaning-of-life"
      ),
    },
    {
      key: "Stargazer",
      title: "Stargazer",
      description: t("a-person-who-predicts-the-fate-by-astrology"),
    },
    {
      key: "Ranger",
      title: "Ranger",
      description: t(
        "a-person-who-protects-the-forest-with-great-fighting-and-surviving-skills"
      ),
    },
    {
      key: "Witch",
      title: "Witch",
      description: t(
        "a-person-who-has-magical-power-to-harm-or-help-other-people"
      ),
    },
    {
      key: "Druid",
      title: "Druid",
      description: t(
        "a-person-who-is-able-to-change-as-an-animal-and-wise-in-the-forest"
      ),
    },
    {
      key: "Wizard",
      title: "Wizard",
      description: t(
        "a-person-who-has-magical-powers-and-studies-the-occultism"
      ),
    },
    {
      key: "Dancer",
      title: "Dancer",
      description: t(
        "a-person-who-performs-a-dance-and-moves-body-rhythmically"
      ),
    },
    {
      key: "Pirate",
      title: "Pirate",
      description: t("a-person-who-robs-or-commits-illegal-violence-at-sea"),
    },
    {
      key: "Friar",
      title: "Friar",
      description: t("a-person-who-dedicates-an-entire-life-to-god"),
    },
    {
      key: "Thief",
      title: "Thief",
      description: t("a-person-who-steals-or-commits-crime-at-the-city"),
    },
    {
      key: "Housecarl",
      title: "Housecarl",
      description: t("a-person-who-protects-and-serves-the-noble"),
    },
    {
      key: "Cavalry",
      title: "Cavalry",
      description: t(
        "a-person-who-rides-the-war-horse-and-shows-excellent-teamwork"
      ),
    },
    {
      key: "Mercenary",
      title: "Mercenary",
      description: t("a-person-who-is-hired-for-service-in-the-army"),
    },
    {
      key: "Scholar",
      title: "Scholar",
      description: t("a-person-who-is-keen-on-knowledge-studies-and-transfer"),
    },
    {
      key: "Pharmacist",
      title: "Pharmacist",
      description: t("a-person-who-collects-herbs-and-makes-medicine"),
    },
    {
      key: "Archaeologist",
      title: "Archaeologist",
      description: t("a-person-who-studies-history-and-ancient-civilization"),
    },
    {
      key: "Writer",
      title: "Writer",
      description: t("a-person-who-writes-somethings-for-living"),
    },
    {
      key: "Storyteller",
      title: "Storyteller",
      description: t("a-person-who-tells-stories-and-entertains-other-people"),
    },
    {
      key: "Gladiator",
      title: "Gladiator",
      description: t(
        "a-person-who-fights-against-other-men-or-wild-animals-in-order-to-entertain-an-audience"
      ),
    },
    {
      key: "Artist",
      title: "Artist",
      description: t("a-person-who-paints-and-makes-sculptures"),
    },
    {
      key: "Sheriff",
      title: "Sheriff",
      description: t("a-person-who-charges-the-criminal-and-protects-the-city"),
    },
    {
      key: "Archer",
      title: "Archer",
      description: t("a-person-who-is-an-expert-in-the-use-of-a-bow-and-arrow"),
    },
    {
      key: "Hunter",
      title: "Hunter",
      description: t(
        "a-person-who-is-lived-by-hunting-animals-for-food-in-the-forest"
      ),
    },
    {
      key: "Chef",
      title: "Chef",
      description: t("a-person-who-cooks-professionally-for-a-living"),
    },
    {
      key: "Sailor",
      title: "Sailor",
      description: t("a-person-who-works-and-lives-on-a-boat"),
    },
    {
      key: "Bard",
      title: "Bard",
      description: t(
        "a-person-who-is-traveling-around-the-world-good-at-signing-songs-and-writing-poems"
      ),
    },
  ];
  let temp = wholeTitleDescription.filter((t) => {
    if (t.title === myTitle) {
      return t;
    }
  });
  return temp[0].description;
}
export function getAvatar(title, fullbody, epic, block = false) {
  // console.log("get Avatar =", title, fullbody, epic);
  let ret = "";
  let anchor;
  let advanced;
  if (epic === 1) {
    epic = false;
  } else if (epic === 2) {
    epic = true;
  }
  if (epic) {
    advanced = "_epic";
  } else {
    advanced = "";
  }
  if (fullbody) {
    anchor = "";
  } else anchor = "_C";
  if (block === false) {
    try {
      switch (title) {
        case "Villager":
          return new URL(
            `../assets/img/avatars/titles/村民${anchor}@2x_epic.png`,
            import.meta.url
          ).href;
          break;
        case "Traveler":
          return new URL(
            `../assets/img/avatars/titles/旅人${anchor}@2x_epic.png`,

            import.meta.url
          ).href;

          break;
        case "Blacksmith":
          return new URL(
            `../assets/img/avatars/titles/鐵匠${anchor}@2x_epic.png`,

            import.meta.url
          ).href;

          break;
        case "Businessman":
          return new URL(
            `../assets/img/avatars/titles/商人${anchor}@2x_epic.png`,

            import.meta.url
          ).href;

          break;
        case "Farmer":
          return new URL(
            `../assets/img/avatars/titles/農夫${anchor}@2x_epic.png`,

            import.meta.url
          ).href;

          break;
        case "Messenger":
          return new URL(
            `../assets/img/avatars/titles/信差${anchor}@2x_epic.png`,

            import.meta.url
          ).href;

          break;
        case "Fisherman":
          return new URL(
            `../assets/img/avatars/titles/漁夫${anchor}@2x_epic.png`,

            import.meta.url
          ).href;

          break;
        case "Carpenter":
          return new URL(
            `../assets/img/avatars/titles/木匠${anchor}@2x_epic.png`,

            import.meta.url
          ).href;

          break;
        case "Sage":
          return new URL(
            `../assets/img/avatars/titles/智者${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;

        case "Berserker":
          return new URL(
            `../assets/img/avatars/titles/狂戰士${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Paladin":
          return new URL(
            `../assets/img/avatars/titles/聖騎士${anchor}@2x${advanced}.png`,
            import.meta.url
          ).href;

          break;
        case "Archbishop":
          // return `https://mangosteems-universe-pub.s3.ap-southeast-1.amazonaws.com/title/大主教${anchor}@2x${advanced}.png`;
          return new URL(
            `../assets/img/avatars/titles/大主教${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Scientist":
          return new URL(
            `../assets/img/avatars/titles/科學家${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Alchemist":
          return new URL(
            `../assets/img/avatars/titles/煉金術士${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Monk":
          return new URL(
            `../assets/img/avatars/titles/僧侶${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Houngan":
          return new URL(
            `../assets/img/avatars/titles/祭司${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Philosopher":
          return new URL(
            `../assets/img/avatars/titles/哲學家${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Stargazer":
          return new URL(
            `../assets/img/avatars/titles/占星師${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Ranger":
          return new URL(
            `../assets/img/avatars/titles/遊俠${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Witch":
          return new URL(
            `../assets/img/avatars/titles/女巫${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Druid":
          return new URL(
            `../assets/img/avatars/titles/德魯伊${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Wizard":
          return new URL(
            `../assets/img/avatars/titles/魔法師${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Knight":
          return new URL(
            `../assets/img/avatars/titles/騎兵${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Dancer":
          return new URL(
            `../assets/img/avatars/titles/舞蹈家${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Bard":
          return new URL(
            `../assets/img/avatars/titles/吟遊詩人${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Pirate":
          return new URL(
            `../assets/img/avatars/titles/海盜${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Friar":
          return new URL(
            `../assets/img/avatars/titles/修道士${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;

          break;
        case "Thief":
          return new URL(
            `../assets/img/avatars/titles/盜賊${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Housecarl":
          return new URL(
            `../assets/img/avatars/titles/侍衛${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Cavalry":
          return new URL(
            `../assets/img/avatars/titles/騎士${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Mercenary":
          return new URL(
            `../assets/img/avatars/titles/傭兵${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Scholar":
          return new URL(
            `../assets/img/avatars/titles/學者${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Pharmacist":
          return new URL(
            `../assets/img/avatars/titles/藥劑師${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Archaeologist":
          return new URL(
            `../assets/img/avatars/titles/考古學家${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Writer":
          return new URL(
            `../assets/img/avatars/titles/作家${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Storyteller":
          return new URL(
            `../assets/img/avatars/titles/說書人${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Gladiator":
          return new URL(
            `../assets/img/avatars/titles/角鬥士${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Artist":
          return new URL(
            `../assets/img/avatars/titles/藝術家${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Sheriff":
          return new URL(
            `../assets/img/avatars/titles/治安官${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Archer":
          return new URL(
            `../assets/img/avatars/titles/弓箭手${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Hunter":
          return new URL(
            `../assets/img/avatars/titles/獵人${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Chef":
          return new URL(
            `../assets/img/avatars/titles/廚師${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        case "Sailor":
          return new URL(
            `../assets/img/avatars/titles/水手${anchor}@2x${advanced}.png`,

            import.meta.url
          ).href;
          break;
        // Other
        case title:
          return new URL(
            `https://mangosteems-universe-pub.s3.ap-southeast-1.amazonaws.com/title/${title}${anchor}@2x${advanced}.png`

            // import.meta.url
          );
          // .href;
          break;
        default:
          return new URL(
            `https://mangosteems-universe-pub.s3.ap-southeast-1.amazonaws.com/title/${title}${anchor}@2x${advanced}.png`
          );
          // .href;
          break;
      }
    } catch (error) {
      return new URL(
        `../assets/img/avatars/titles/村民${anchor}@2x.png`,

        import.meta.url
      ).href;
      console.error(error);
    }
    return ret;
  } else {
    return new URL(
      `https://mangosteems-universe-pub.s3.ap-southeast-1.amazonaws.com/title/black%2Bicon_${title}${anchor}%402x${advanced}.png`
    );
  }
}

// export function getAvatar(title, fullbody, epic, block = false) {
//   let ret = "";
//   let anchor;
//   let advanced;
//   if (epic === 1) {
//     epic = false;
//   } else if (epic === 2) {
//     epic = true;
//   }
//   if (epic) {
//     advanced = "_epic";
//   } else {
//     advanced = "";
//   }
//   if (fullbody) {
//     anchor = "";
//   } else anchor = "_C";
//   try {
//     switch (title) {
//       case "Villager":
//         return new URL(
//           `../assets/img/avatars/titles/村民${anchor}@2x_epic.png`,
//           import.meta.url
//         ).href;
//         break;
//       case "Traveler":
//         return new URL(
//           `../assets/img/avatars/titles/旅人${anchor}@2x_epic.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Blacksmith":
//         return new URL(
//           `../assets/img/avatars/titles/鐵匠${anchor}@2x_epic.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Businessman":
//         return new URL(
//           `../assets/img/avatars/titles/商人${anchor}@2x_epic.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Farmer":
//         return new URL(
//           `../assets/img/avatars/titles/農夫${anchor}@2x_epic.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Messenger":
//         return new URL(
//           `../assets/img/avatars/titles/信差${anchor}@2x_epic.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Fisherman":
//         return new URL(
//           `../assets/img/avatars/titles/漁夫${anchor}@2x_epic.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Carpenter":
//         return new URL(
//           `../assets/img/avatars/titles/木匠${anchor}@2x_epic.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Sage":
//         return new URL(
//           `../assets/img/avatars/titles/智者${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;

//       case "Berserker":
//         return new URL(
//           `../assets/img/avatars/titles/狂戰士${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Paladin":
//         return new URL(
//           `../assets/img/avatars/titles/聖騎士${anchor}@2x${advanced}.png`,
//           import.meta.url
//         ).href;

//         break;
//       case "Archbishop":
//         return new URL(
//           `../assets/img/avatars/titles/大主教${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Scientist":
//         return new URL(
//           `../assets/img/avatars/titles/科學家${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Alchemist":
//         return new URL(
//           `../assets/img/avatars/titles/煉金術士${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Monk":
//         return new URL(
//           `../assets/img/avatars/titles/僧侶${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Houngan":
//         return new URL(
//           `../assets/img/avatars/titles/祭司${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Philosopher":
//         return new URL(
//           `../assets/img/avatars/titles/哲學家${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Stargazer":
//         return new URL(
//           `../assets/img/avatars/titles/占星師${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Ranger":
//         return new URL(
//           `../assets/img/avatars/titles/遊俠${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Witch":
//         return new URL(
//           `../assets/img/avatars/titles/女巫${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Druid":
//         return new URL(
//           `../assets/img/avatars/titles/德魯伊${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Wizard":
//         return new URL(
//           `../assets/img/avatars/titles/魔法師${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Knight":
//         return new URL(
//           `../assets/img/avatars/titles/騎兵${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Dancer":
//         return new URL(
//           `../assets/img/avatars/titles/舞蹈家${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Bard":
//         return new URL(
//           `../assets/img/avatars/titles/吟遊詩人${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Pirate":
//         return new URL(
//           `../assets/img/avatars/titles/海盜${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Friar":
//         return new URL(
//           `../assets/img/avatars/titles/修道士${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;

//         break;
//       case "Thief":
//         return new URL(
//           `../assets/img/avatars/titles/盜賊${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Housecarl":
//         return new URL(
//           `../assets/img/avatars/titles/侍衛${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Cavalry":
//         return new URL(
//           `../assets/img/avatars/titles/騎士${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Mercenary":
//         return new URL(
//           `../assets/img/avatars/titles/傭兵${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Scholar":
//         return new URL(
//           `../assets/img/avatars/titles/學者${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Pharmacist":
//         return new URL(
//           `../assets/img/avatars/titles/藥劑師${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Archaeologist":
//         return new URL(
//           `../assets/img/avatars/titles/考古學家${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Writer":
//         return new URL(
//           `../assets/img/avatars/titles/作家${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Storyteller":
//         return new URL(
//           `../assets/img/avatars/titles/說書人${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Gladiator":
//         return new URL(
//           `../assets/img/avatars/titles/角鬥士${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Artist":
//         return new URL(
//           `../assets/img/avatars/titles/藝術家${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Sheriff":
//         return new URL(
//           `../assets/img/avatars/titles/治安官${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Archer":
//         return new URL(
//           `../assets/img/avatars/titles/弓箭手${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Hunter":
//         return new URL(
//           `../assets/img/avatars/titles/獵人${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Chef":
//         return new URL(
//           `../assets/img/avatars/titles/廚師${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//       case "Sailor":
//         return new URL(
//           `../assets/img/avatars/titles/水手${anchor}@2x${advanced}.png`,

//           import.meta.url
//         ).href;
//         break;
//     }
//   } catch (error) {
//     return new URL(
//       `../assets/img/avatars/titles/村民${anchor}@2x.png`,

//       import.meta.url
//     ).href;
//     console.error(error);
//   }
//   return ret;
// }
